import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const fetchConfig = createAsyncThunk(
  'resource/fetchConfig',
  async (_, { extra, rejectWithValue }) => {
    const { connectClient, endpoints } = extra;
    try {
      const { data } = await connectClient.get(endpoints.FETCH_CONFIG);
      return data;
    } catch (err) {
      const { response } = err;
      return rejectWithValue(response.data);
    }
  }
);

const resourcesSlice = createSlice({
  name: 'resources',
  initialState: {
    config: {},
    pending: false,
    showMessage: false,
    message: '',
    currentPage: '/',
  },
  reducers: {
    setCurrentPage: (state, { payload }) => {
      state.currentPage = payload;
    },
    setPending: (state, { payload }) => {
      state.pending = payload;
    },
    removeMessage: (state) => {
      state.showMessage = false;
    },
    setMessage: (state, { payload }) => {
      state.showMessage = true;
      state.message = payload;
    },
  },
  extraReducers: {
    [fetchConfig.pending]: (state) => {
      state.pending = true;
    },
    [fetchConfig.fulfilled]: (state, { payload }) => {
      state.config = payload;
      state.pending = false;
    },
    [fetchConfig.rejected]: (state, { payload }) => {
      state.showMessage = true;
      state.pending = false;
      state.message = payload.message;
    },
  },
});

export const {
  setCurrentPage,
  setPending,
  removeMessage,
  setMessage,
} = resourcesSlice.actions;

export default resourcesSlice.reducer;
